// import type { FC } from "react"
// import type { SvgIcons } from "../../type/Icons"

// export const DisabledMusin: FC<SvgIcons>=({fill,width,height})=>{
//     return (<>
//     <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width={width ?? "32"} height={height ?? "32"} fill={fill ?? "none"} className="size-6 transition-transform duration-300"> <path fill={fill ?? "currentColor"} d="m10.902 8.15 3.703 3.676-2.4 1.058a1.22 1.22 0 0 0-.746 1.12l.024 9.835c-.005 1.004-.543 1.85-1.305 2.44-.752.58-3.444 2.526-4.52 2.944-.854.33-1.853-.086-2.246-1.222-.365-1.058-.137-2.692 1.18-3.702.728-.561 1.863-.98 2.698-.615.28-.154.532-.3.723-.429.351-.237.595-.597.589-1.02l-.167-10.981c0-1.354.607-2.241 1.656-2.745l.812-.36M21.94 19.107l2.504 2.484a3.5 3.5 0 0 1-.588.607c-1.352 1.109-3.585 2.474-4.212 2.724-.9.359-1.834-.095-2.159-.88-.387-.937-.741-2.797 1.077-3.975 1.06-.686 1.803-.575 2.473-.427.347-.175.437-.221.681-.364q.124-.071.223-.168zM10.041 4.342 28.78 22.944a1.04 1.04 0 0 1 .005 1.471l-.005.005a1.055 1.055 0 0 1-1.487 0L8.553 5.818a1.04 1.04 0 0 1-.005-1.471l.006-.005a1.055 1.055 0 0 1 1.487 0m15.036-.251-.001 13.996-2.782-2.762v-6.11a.508.508 0 0 0-.697-.469l-4.107 1.809-3.703-3.676 9.277-4.087c.946-.418 2.014.27 2.014 1.299z"></path> </svg></>)
// }

import type { FC } from "react";
import type { SvgIcons } from "../../type/Icons";

export const DisabledMusin: FC<SvgIcons> = ({ fill, width, height }) => {
  return (
    <>
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "32"}
        height={height ?? "32"}
        fill={fill ?? "none"}
        className="size-6 transition-transform duration-300"
      >
        {" "}
        <path
          fill={fill ?? "currentColor"}
          d="m10.902 8.15 3.703 3.676-2.4 1.058a1.22 1.22 0 0 0-.746 1.12l.024 9.835c-.005 1.004-.543 1.85-1.305 2.44-.752.58-3.444 2.526-4.52 2.944-.854.33-1.853-.086-2.246-1.222-.365-1.058-.137-2.692 1.18-3.702.728-.561 1.863-.98 2.698-.615.28-.154.532-.3.723-.429.351-.237.595-.597.589-1.02l-.167-10.981c0-1.354.607-2.241 1.656-2.745l.812-.36M21.94 19.107l2.504 2.484a3.5 3.5 0 0 1-.588.607c-1.352 1.109-3.585 2.474-4.212 2.724-.9.359-1.834-.095-2.159-.88-.387-.937-.741-2.797 1.077-3.975 1.06-.686 1.803-.575 2.473-.427.347-.175.437-.221.681-.364q.124-.071.223-.168zM10.041 4.342 28.78 22.944a1.04 1.04 0 0 1 .005 1.471l-.005.005a1.055 1.055 0 0 1-1.487 0L8.553 5.818a1.04 1.04 0 0 1-.005-1.471l.006-.005a1.055 1.055 0 0 1 1.487 0m15.036-.251-.001 13.996-2.782-2.762v-6.11a.508.508 0 0 0-.697-.469l-4.107 1.809-3.703-3.676 9.277-4.087c.946-.418 2.014.27 2.014 1.299z"
        ></path>{" "}
      </svg>
    </>
  );
};

export default DisabledMusin;
